<div class="out" if="out" #out>
  <!-- <assets-header *ngIf="!bSmall" [bShowSigners]="false" class="hdr"> </assets-header> -->

  <youtube-player *ngIf="height>0" #ytplayer class="youtube" modestbranding="true" [width]="width" [height]="height" (ready)="setupPlayer($event)" (change)="updatePlayerState($event)" [videoId]="video_id" poster="assets/images/youtube.png">
  </youtube-player>
  <!-- <div class="abs_center"> width {{width}},{{height}} </div>-->

</div>
